var exports = {
  "u": "ExternalLink.module__externalLink___bkMtTk",
};

module.exports = exports;
